import styled from 'styled-components';
import DeliveryInfo from '@shopDetails/components/DeliveryInfo';

const StyledDeliveryInfo = styled(DeliveryInfo)`
  padding-bottom: ${({ theme }) => theme.spacing(6)};
  * {
    color: ${({ theme }) => theme.colors.night_blue_2};
  }
`;

export default StyledDeliveryInfo;
